import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClickOutside from 'react-click-outside';
import { omit } from 'lodash';
import { Wrapper, Label, Arrow, Overlay, Content } from './styles';

class Dropdown extends Component {
	static propTypes = {
		label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		openLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		open: PropTypes.bool,
		defaultOpen: PropTypes.bool,
		leftAlign: PropTypes.bool,
		afterContent: PropTypes.any,
		renderLabel: PropTypes.func,
		onChangeOpen: PropTypes.func,
		hideOpenLabel: PropTypes.bool,
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		onChangeOpen: () => {},
		defaultOpen: false,
		leftAlign: false,
	};

	state = {
		open: this.props.defaultOpen,
	};

	labelNode = null;

	componentDidUpdate(prevProps) {
		const { open: openProp } = this.props;
		const { open } = this.state;

		if (openProp !== prevProps.open && openProp !== open) {
			this.setState({ open: openProp });
		}
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	render() {
		const {
			label,
			openLabel,
			children,
			leftAlign,
			afterContent,
			hideOpenLabel,
			disabled,
			renderLabel = (text, ref) => (
				<Label
					disabled={disabled}
					open={open}
					onClick={this.handleLabelClick}
					innerRef={ref}
				>
					{text}
					<Arrow open={open} />
				</Label>
			),
			...props
		} = this.props;
		const open = disabled ? false : this.state.open || this.props.open;
		const {
			width: labelWidth = 0,
			y: labelY = 0,
			height: labelHeight = 0,
		} = this.getRect(this.labelNode);
		const yOffset = hideOpenLabel ? labelHeight : 0;

		return (
			<Wrapper {...omit(props, ['defaultOpen', 'onChangeOpen'])} open={open}>
				{renderLabel(label, ref => (this.labelNode = ref))}
				{open && (
					<ClickOutside onClickOutside={this.handleClickOutside}>
						<Overlay
							leftAlign={leftAlign}
							style={{
								top: hideOpenLabel ? labelHeight : 0,
								minWidth: labelWidth,
								maxHeight: window.innerHeight - (labelY + yOffset + 10),
							}}
						>
							{!hideOpenLabel && renderLabel(openLabel || label)}
							<Content>{children}</Content>
							{afterContent}
						</Overlay>
					</ClickOutside>
				)}
			</Wrapper>
		);
	}

	getRect(node) {
		return node ? node.getBoundingClientRect() : {};
	}

	handleResize = () => this.forceUpdate();

	close = () => {
		const nextOpen = false;
		this.setState({ open: nextOpen });
		this.props.onChangeOpen(nextOpen);
	};

	handleClickOutside = e => {
		if (!this.labelNode.contains(e.target)) {
			if (this.state.open) this.close();
		}
	};

	handleLabelClick = () => {
		const { open = this.state.open } = this.props;
		const nextOpen = !open;
		this.setState({ open: nextOpen });
		this.props.onChangeOpen(nextOpen);
	};
}

export default Dropdown;
